import { cloneDeep } from "lodash"

import {
  addonDetailsType,
  CartItemType,
  GetCartResponseType,
} from "@mono/essentials/entities/cart/types"
import {
  GetOrderDetailsResponseType,
  OrderItemType,
  ProductCategoryTypes,
} from "@mono/essentials/types/OrderTypes"

export const getAddonsInfoOfCartItem = ({
  cartData,
  cartItem,
  orderData,
  orderItem,
}: {
  cartItem?: CartItemType
  cartData?: GetCartResponseType["data"]
  orderItem?: OrderItemType
  orderData?: GetOrderDetailsResponseType
}): addonDetailsType[] => {
  const groupedAddons: addonDetailsType[] = []
  cloneDeep(cartData || orderData)
    ?.items.filter(
      (ci) =>
        ci.product.type.internal_type === ProductCategoryTypes.ADD_ONS &&
        (ci.parent_id === cartItem?.id || ci.parent_id === orderItem?.id)
    )
    .forEach((addon) => {
      const addonProductIndex = groupedAddons.findIndex(
        (ga) => ga?.addonId && addon?.product?.id && ga.addonId === addon.product.id
      )
      if (addonProductIndex >= 0 && addon?.quantities?.length) {
        groupedAddons[addonProductIndex]?.units?.push({
          id: addon.id,
          unitCount: addon.quantities[0].quantity,
          unitName: addon.quantities[0].unit?.name,
          unitId: addon.quantities[0].unit?.id,
          participantId:
            (addon as CartItemType).cart_participant_id ??
            (addon as OrderItemType).booking_participant_id ??
            undefined,
        })
      } else {
        groupedAddons.push({
          addonId: addon.product.id,
          availability: (addon.product.merchandise?.availability ??
            (addon as OrderItemType).product.meta?.merchandise
              ?.availability) as addonDetailsType["availability"],
          requirement: (addon.product.merchandise?.requirements ??
            (addon as OrderItemType).product.meta?.merchandise
              ?.requirements) as addonDetailsType["requirement"],
          units: addon.quantities.map((unit) => ({
            id: addon.id,
            unitCount: unit.quantity,
            unitName: unit.unit?.name,
            unitId: unit.unit?.id,
            participantId:
              (addon as CartItemType).cart_participant_id ??
              (addon as OrderItemType).booking_participant_id ??
              undefined,
          })),
        })
      }
    })
  return groupedAddons
}
